module.exports = __webpack_public_path__ + "static/media/solution-tube-a_--opened.f9570210.svg";